class ActionTypes {
  static CLEAR_ALL = 'CLEAR_ALL';
  static USER_LOADING = 'USER_LOADING';
  static USER_ERROR = 'USER_ERROR';
  static DELETE_ACCOUNT_ERROR = 'DELETE_ACCOUNT_ERROR';
  static USER_LOGGED_IN = 'USER_LOGGED_IN';
  static DELETING_ACCOUNT = 'DELETING_ACCOUNT';
  static USER_SETTINGS_UPDATED = 'USER_SETTINGS_UPDATED';

  static DAY_CHANGED = 'DAY_CHANGED';
  static MOBILE_BLOCK_CONTINUE_CLICKED = 'MOBILE_BLOCK_CONTINUE_CLICKED';
  static INITIALIZED = 'INITIALIZED';
  static DASHBOARD_MENU_ITEM_CLICKED = 'DASHBOARD_MENU_ITEM_CLICKED';
  static ACTIVITY_ADD_CLICKED = 'ACTIVITY_ADD_CLICKED';
  static ACTIVITY_ADD_TIME_CLICKED = 'ACTIVITY_ADD_TIME_CLICKED';
  static WORK_LOG_BLOCK_CLICKED = 'WORK_LOG_BLOCK_CLICKED';
  static TIMER_PROJECT_CLICKED = 'TIMER_PROJECT_CLICKED';
  static PROJECT_CLICKED = 'PROJECT_CLICKED';
  static ADD_PROJECT_CLICKED = 'ADD_PROJECT_CLICKED';
  static EDIT_PROJECT_CLICKED = 'EDIT_PROJECT_CLICKED';
  static HISTORY_DETAILS_CLICKED = 'HISTORY_DETAILS_CLICKED';
  static SHOW_DIALOG = 'SHOW_DIALOG';

  static WORK_LOG_LOADING_TODAY = 'WORK_LOG_LOADING_TODAY';
  static WORK_LOG_CREATED = 'WORK_LOG_CREATED';
  static WORK_LOG_UPDATED = 'WORK_LOG_UPDATED';
  static WORK_LOG_DELETED = 'WORK_LOG_DELETED';
  static WORK_LOG_TODAY_FAILED = 'WORK_LOG_TODAY_FAILED';
  static WORK_LOG_TODAY_CLEAR = 'WORK_LOG_TODAY_CLEAR';
  static WORK_LOG_UPDATING = 'WORK_LOG_UPDATING';

  static WORK_LOGS_HISTORY = 'WORK_LOGS_HISTORY';

  static PROJECTS_LOADING = 'PROJECTS_LOADING';
  static PROJECTS_FAILED = 'PROJECTS_FAILED';
  static PROJECT_CREATED = 'PROJECT_CREATED';
  static PROJECT_DELETED = 'PROJECT_DELETED';
  static PROJECT_UPDATED = 'PROJECT_UPDATED';
  static PROJECT_UPDATING = 'PROJECT_UPDATING';

  static PROJECT_DETAILS_WORK_LOG_CLEAR = 'PROJECT_DETAILS_WORK_LOG_CLEAR';
  static PROJECT_DETAILS_WORK_LOG_FETCHED = 'PROJECT_DETAILS_WORK_LOG_FETCHED';

  static SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';

  static TOGGLE_TODAY_LIST_MODE = 'TOGGLE_TODAY_LIST_MODE';
  static TOGGLE_HISTORY_LIST_MODE = 'TOGGLE_HISTORY_LIST_MODE';

  static ACCEPTING_INVITATION = 'ACCEPTING_INVITATION';
}

export default ActionTypes;



// WEBPACK FOOTER //
// ./src/common/ActionTypes.js